import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: "#002D55",
    height: 'clamp(20px, 2.2vw, 36px)',
    width: 'clamp(20px, 2.2vw, 36px)',
  }
}));

const WeeklyGoal = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs={1} style={{marginRight: 30}}>
            <Avatar className={classes.avatar}><LibraryAddCheckIcon /></Avatar>
          </Grid>
          <Grid item xs={10}>
            <Typography
              style={{color: "#002D55", marginBottom: 5}}
              variant="h4"
            >
              WEEKLY GOAL
            </Typography>
            <Typography
              style={{marginTop: 5, marginBottom: 5}}
              color="textSecondary"
              gutterBottom
              variant="h7"
              xs={10}
            >
              Complete and track a minimum of 80 % of your exercises for {"X"} days to unlock the next phase of your rehabilitation program. 
            </Typography>
            <Typography
              style={{color: "#002D55", marginTop: 15}}
              variant="h4"
            >
              75.5%
            </Typography>
            <Box mt={1}>
              <LinearProgress
              value={75.5}
              variant="determinate"
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

WeeklyGoal.propTypes = {
  className: PropTypes.string
};

export default WeeklyGoal;